import pluralize from 'pluralize'
import {
  COACHING_INBOX,
  IGNORED,
  LOADING_PHRASES,
  COACHING_QUESTIONS,
  READY_FOR_REVIEW,
} from './tasks.constants'

export const getPatchedTaskText = (body = {}, inboxType) => {
  const isDismiss = body.status === IGNORED
  const isReopen = body.status === READY_FOR_REVIEW
  const completedText = inboxType === COACHING_INBOX ? 'Sent' : 'Reviewed'

  if (isDismiss) {
    return 'Dismissed'
  }

  if (isReopen) {
    return 'Reopened'
  }

  return completedText
}

export const isRemoveEvidenceDisabled = (
  evidence = [],
  callIdDeleteQueue = [],
  callIdDeleteCompleted = []
) => {
  if (evidence.length <= 1) {
    return true
  }

  const queueLength = callIdDeleteQueue.length + callIdDeleteCompleted.length
  const lastRemainingEvidence = evidence.length <= queueLength + 1

  if (lastRemainingEvidence) {
    return true
  }

  return false
}

const getChannelNouns = (channel = 'call') => {
  const singular = channel
  const plural = pluralize(channel)
  return { singular, plural }
}

export const replaceChannelTokens = (str, channel = 'call') => {
  const { singular, plural } = getChannelNouns(channel)
  return str.replaceAll('{channel}', plural).replaceAll('{channel_singular}', singular)
}

export const getLoadingPhrases = (channel) =>
  LOADING_PHRASES.map((phrase) => replaceChannelTokens(phrase, channel))

export const getCoachingQuestionsWithChannel = (channel) =>
  Object.fromEntries(
    Object.entries(COACHING_QUESTIONS).map(([category, questions]) => [
      category,
      questions.map((q) => replaceChannelTokens(q, channel)),
    ])
  )

export const getActiveCoachingPopupContent = (channel) => {
  const content =
    'AI Coaching automatically reviews every {channel_singular} and gives this agent immediate feedback for the next 14 days.'
  return replaceChannelTokens(content, channel)
}
